export default "__VITE_ASSET__Fe8ylRiV__"